/* eslint-disable no-negated-condition, import/no-unresolved */
/**
 * @description
 *
 * When LAUNCHING the app (`NODE_ENV` set to "development"),
 * the config is generated on the fly.
 *
 * When BUILDING the app (`NODE_ENV` set to "production"),
 * the config is imported from the pre-built static `<project_root>/build/config.json` file.
 * If the app has been built with "env override" mode enabled, the config is imported from the
 * corresponding environment of the nested `configByEnv` key of the static file.
 */
const isPlainObject = require('lodash/isPlainObject');
const { appEnableEnvOverride, appEnv, appCustomer, appPlatform } = require('@bedrock-rdk/utils/src/env');

let config = {};

// ⚠️ KEEP NEGATED CONDITION FOR TREE-SHAKING (remove config.generator require from build)
if (process.env.NODE_ENV !== 'production') {
  config = require('./config.generator')(appEnv, appCustomer, appPlatform);
} else {
  config = require('../../../../public/config.json');

  if (appEnableEnvOverride) {
    if (!isPlainObject(config.configByEnv)) {
      throw new Error(
        `Cannot get config for "${appEnv}" env: \`config.configByEnv\` is not a valid object.
Ensure that you have pre-built the config with env override flag: \`APP_ENABLE_ENV_OVERRIDE=true ... pnpm build-config\``,
      );
    }

    if (!isPlainObject(config.configByEnv[appEnv])) {
      throw new Error(
        `Cannot get config for "${appEnv}" env: \`config.configByEnv['${appEnv}']\` is not a valid object.`,
      );
    }
    config = { ...config.configByEnv[appEnv] };
  }
}

module.exports = config;
